// import {
//    Box,
//    Flex,
//    useColorModeValue,
//    Avatar,
//    Text,
//    Badge,
//    VStack,
//    HStack,
//    IconButton,
//    Button,
//    Menu,
//    MenuButton,
//    MenuList,
//    MenuItem,
//    useDisclosure,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Checkbox,
//    Spacer,
//    Divider,
//    Tooltip,
//    Spinner,
//    Tabs,
//    TabList,
//    Tab,
// } from '@chakra-ui/react';
// import { EditIcon, DeleteIcon } from '@chakra-ui/icons';
// import { TbSwitchVertical } from 'react-icons/tb';
// import React, { useEffect, useState, useRef } from 'react';
// import { CiMenuKebab, CiShare2, CiPhone, CiMail } from 'react-icons/ci';
// import { getUser, deleteUser, updateUserStatus } from '../../../redux/actions/user';
// import { useSelector, useDispatch } from 'react-redux';
// import ManageUserRoleForm from './ManageUserRoleForm';
// import DeleteDialog from 'views/admin/masters/components/DeleteDialog';
// import { getCompanies } from '../../../redux/actions/company';
// import AddUserModal from './ManageUserForm';
// import { Link } from 'react-router-dom';
// import { IoMdArrowRoundBack } from 'react-icons/io';
// import moment from 'moment';
// import { useGlobal } from '../../../contexts';
// import { USER_TYPE_OPTIONS } from 'constants';

// export default function ManageUsers(props) {
//    const [selectedMember, setSelectedMember] = useState(null);
//    const [userId, setUserId] = useState(null);
//    const [companyId, setCompanyId] = useState('');
//    const [error, setError] = useState('');
//    const [isEditMode, setIsEditMode] = useState(false);
//    const [updatingStatus, setUpdatingStatus] = useState(null);
//    const { isOpen, onOpen, onClose } = useDisclosure();
//    const setIsOpen = (value) => {
//       if (value) {
//          onOpen();
//       } else {
//          onClose();
//       }
//    };
//    const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
//    const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
//    const backgroundColor = useColorModeValue('white', '#101F4A');
//    const textColor = useColorModeValue('secondaryGray.900', 'white');
//    const { companyList } = useGlobal();

//    const dispatch = useDispatch();
//    const list = useSelector((state) => state.user.list);
//    const user = useSelector((state) => state.user?.profile);

//    const { isOpen: isRoleModel, onOpen: onRoleModelOpen, onClose: onCloseRoleModel } = useDisclosure();

//    useEffect(() => {
//       const fetchData = async () => {
//          try {
//             await dispatch(getUser());
//          } catch (error) {
//             console.error('Error fetching data:', error);
//          }
//       };

//       fetchData();
//    }, [dispatch]);

//    const [isShareToCompanyModalOpen, setIsShareToCompanyModalOpen] = useState(false);

//    const handleCloseShareToCompanyModal = () => {
//       setIsShareToCompanyModalOpen(false);
//    };

//    const handleStatusToggle = async (member) => {
//       setUpdatingStatus(member.id);
//       try {
//          await dispatch(updateUserStatus(member.id, !member.status));
//       } catch (error) {
//          console.error('Error updating status:', error);
//       } finally {
//          setUpdatingStatus(null);
//       }
//    };

//    const [selectedCompanies, setSelectedCompanies] = useState({
//       'Comp Update': false,
//       'Long Best Co': false,
//       'SS WEB CREATION': false,
//       'TEST COMPANY NAME': false,
//    });

//    const handleCompanyChange = (companyName) => {
//       setSelectedCompanies((prev) => ({
//          ...prev,
//          [companyName]: !prev[companyName],
//       }));
//    };

//    const handleShareCompany = () => {
//       const selectedCompanyData = {};

//       Object.keys(selectedCompanies).forEach((company) => {
//          selectedCompanyData[company.toLowerCase()] = {
//             companyName: company,
//             isSelected: selectedCompanies[company],
//          };
//       });

//       setIsShareToCompanyModalOpen(false);
//    };

//    const handleEdit = (member) => {
//       setSelectedMember(member);
//       setUserId(member.id);
//       setIsEditMode(true);
//       setCompanyId(member.companyId);
//       onOpen();
//    };

//    const [selectedRowId, setSelectedRowId] = useState(null);
//    const [data, setData] = useState([]);

//    const handleDelete = async (member) => {
//       setSelectedRowId(member.id);
//       setDeleteDialogOpen(true);
//    };

//    const handleConfirmDelete = async () => {
//       if (selectedRowId !== null) {
//          try {
//             await dispatch(deleteUser(selectedRowId));
//             setData(data?.filter((row) => row.id !== selectedRowId));
//             setDeleteDialogOpen(false); // Close the dialog after deletion
//             await dispatch(getUser());
//          } catch (err) {
//             // console.error('Failed to delete series:', err);
//          }
//       }
//    };

//    const handleAddNew = () => {
//       setIsEditMode(false);
//       setError('');
//       onOpen();
//    };

//    const scrollContainerRef = useRef(null);

//    // Effect to enable smooth scrolling
//    useEffect(() => {
//       const handleScroll = (e) => {
//          // Optional: Add any scroll behavior customization here
//       };

//       const scrollContainer = scrollContainerRef.current;
//       if (scrollContainer) {
//          scrollContainer.addEventListener('scroll', handleScroll);
//       }

//       return () => {
//          if (scrollContainer) {
//             scrollContainer.removeEventListener('scroll', handleScroll);
//          }
//       };
//    }, []);

//    useEffect(() => {
//       const handleKeyDown = (event) => {
//          // Check if the pressed key is '+' or '=' (since + is Shift + =)
//          if (event.key === '+' || (event.key === '=' && event.shiftKey)) {
//             // Prevent default behavior
//             event.preventDefault();
//             handleAddNew();
//          }
//       };

//       // Add event listener to document
//       document.addEventListener('keydown', handleKeyDown);

//       // Cleanup function to remove event listener
//       return () => {
//          document.removeEventListener('keydown', handleKeyDown);
//       };
//    }, []); // Dependencies

//    const [activeTab, setActiveTab] = useState(1); // 0: All, 1: Active, 2: Inactive

//    // Filter users based on active tab
//    const getFilteredUsers = () => {
//       const filteredList = list.filter((member) => member.id !== user?.id);

//       if (activeTab === 0) return filteredList; // All
//       if (activeTab === 1) return filteredList.filter((member) => member.status); // Active
//       if (activeTab === 2) return filteredList.filter((member) => !member.status); // Inactive

//       return filteredList;
//    };

//    const filteredUsers = getFilteredUsers();

//    const allCount = list?.filter((member) => member.id !== user?.id).length || 0;
//    const activeCount = list?.filter((member) => member.id !== user?.id && member.status).length || 0;
//    const inactiveCount = list?.filter((member) => member.id !== user?.id && !member.status).length || 0;

//    const tabBg = useColorModeValue('white', 'gray.800');
//    const tabBorderColor = useColorModeValue('gray.200', 'gray.600');
//    // const textColor = useColorModeValue('gray.600', 'gray.300');

//    // Tab specific colors
//    const allTabActiveBg = useColorModeValue('blue.50', 'blue.900');
//    const allTabActiveColor = useColorModeValue('blue.600', 'blue.300');
//    const allTabBadgeBg = useColorModeValue('blue.100', 'blue.800');
//    const allTabBadgeColor = useColorModeValue('blue.600', 'blue.200');
//    const inactiveBadgeBg = useColorModeValue('gray.100', 'gray.700');
//    const inactiveBadgeColor = useColorModeValue('gray.600', 'gray.400');

//    const activeTabActiveBg = useColorModeValue('green.50', 'green.900');
//    const activeTabActiveColor = useColorModeValue('green.600', 'green.300');
//    const activeTabBadgeBg = useColorModeValue('green.100', 'green.800');
//    const activeTabBadgeColor = useColorModeValue('green.600', 'green.200');

//    const inactiveTabActiveBg = useColorModeValue('red.50', 'red.900');
//    const inactiveTabActiveColor = useColorModeValue('red.600', 'red.300');
//    const inactiveTabBadgeBg = useColorModeValue('red.100', 'red.800');
//    const inactiveTabBadgeColor = useColorModeValue('red.600', 'red.200');

//    const inactiveTabColor = useColorModeValue('gray.600', 'gray.400');

//    return (
//       <>
//          <Flex
//             minH={{ base: '85vh', lg: '85vh', xl: '85vh' }}
//             maxH={{ base: '85vh', lg: '85vh', xl: '85vh' }}
//             // overflowY="auto"
//             direction="column"
//             w="100%">
//             <Box p="10px" borderRadius="10px" w="100%">
//                {/* Modern Tab Interface */}
//                <Box mb={0} mt={6}>
//                   <Tabs
//                      position="relative"
//                      variant="unstyled"
//                      index={activeTab}
//                      onChange={(index) => setActiveTab(index)}>
//                      <TabList
//                         bg={tabBg}
//                         borderRadius="full"
//                         p={1}
//                         boxShadow="sm"
//                         border="1px solid"
//                         borderColor={tabBorderColor}
//                         display="inline-flex"
//                         gap={1}>
//                         <Tab
//                            _selected={{
//                               color: allTabActiveColor,
//                               fontWeight: '600',
//                            }}
//                            borderRadius="full"
//                            px={6}
//                            py={2}
//                            fontSize="sm"
//                            transition="all 0.2s"
//                            position="relative"
//                            bg={activeTab === 0 ? allTabActiveBg : 'transparent'}
//                            color={activeTab === 0 ? allTabActiveColor : inactiveTabColor}
//                            _hover={{ color: allTabActiveColor }}>
//                            All
//                            <Badge
//                               ml={2}
//                               bg={activeTab === 0 ? allTabBadgeBg : inactiveBadgeBg}
//                               color={activeTab === 0 ? allTabBadgeColor : inactiveBadgeColor}
//                               borderRadius="full"
//                               fontSize="xs"
//                               px={2}
//                               py={0.5}>
//                               {allCount}
//                            </Badge>
//                         </Tab>
//                         <Tab
//                            _selected={{
//                               color: activeTabActiveColor,
//                               fontWeight: '600',
//                            }}
//                            borderRadius="full"
//                            px={6}
//                            py={2}
//                            fontSize="sm"
//                            transition="all 0.2s"
//                            position="relative"
//                            bg={activeTab === 1 ? activeTabActiveBg : 'transparent'}
//                            color={activeTab === 1 ? activeTabActiveColor : inactiveTabColor}
//                            _hover={{ color: activeTabActiveColor }}>
//                            Active
//                            <Badge
//                               ml={2}
//                               bg={activeTab === 1 ? activeTabBadgeBg : inactiveBadgeBg}
//                               color={activeTab === 1 ? activeTabBadgeColor : inactiveBadgeColor}
//                               borderRadius="full"
//                               fontSize="xs"
//                               px={2}
//                               py={0.5}>
//                               {activeCount}
//                            </Badge>
//                         </Tab>
//                         <Tab
//                            _selected={{
//                               color: inactiveTabActiveColor,
//                               fontWeight: '600',
//                            }}
//                            borderRadius="full"
//                            px={6}
//                            py={2}
//                            fontSize="sm"
//                            transition="all 0.2s"
//                            position="relative"
//                            bg={activeTab === 2 ? inactiveTabActiveBg : 'transparent'}
//                            color={activeTab === 2 ? inactiveTabActiveColor : inactiveTabColor}
//                            _hover={{ color: inactiveTabActiveColor }}>
//                            Inactive
//                            <Badge
//                               ml={2}
//                               bg={activeTab === 2 ? inactiveTabBadgeBg : inactiveBadgeBg}
//                               color={activeTab === 2 ? inactiveTabBadgeColor : inactiveBadgeColor}
//                               borderRadius="full"
//                               fontSize="xs"
//                               px={2}
//                               py={0.5}>
//                               {inactiveCount}
//                            </Badge>
//                         </Tab>
//                      </TabList>
//                   </Tabs>
//                </Box>

//                <Flex justifyContent="space-between" w="100%">
//                   <Flex mt="30px" justifyItems="center" gap={4}>
//                      <Link to="/admin/setting">
//                         <Button mb="15px">
//                            <IoMdArrowRoundBack size={18} />
//                         </Button>
//                      </Link>

//                      <HStack mb={6} justify="space-between">
//                         <Text fontSize="2xl" fontWeight="bold">
//                            Users
//                         </Text>
//                      </HStack>
//                   </Flex>
//                   <Flex>
//                      <Button
//                         onClick={handleAddNew}
//                         variant="darkBrand"
//                         color="white"
//                         fontSize="sm"
//                         fontWeight="500"
//                         borderRadius="full"
//                         p={{ base: '4', lg: '5' }}
//                         mt="30px"
//                         boxShadow="lg">
//                         Add new
//                      </Button>
//                   </Flex>
//                </Flex>

//                {/* User Cards */}
//                {filteredUsers.length === 0 ? (
//                   <Flex
//                      direction="column"
//                      align="center"
//                      justify="center"
//                      minH="300px"
//                      bg={backgroundColor}
//                      borderRadius="lg"
//                      p={8}>
//                      <Text fontSize="lg" color="gray.500" fontWeight="500">
//                         No {activeTab === 1 ? 'active' : activeTab === 2 ? 'inactive' : ''} users found
//                      </Text>
//                      <Text fontSize="sm" color="gray.400" mt={2}>
//                         {activeTab === 0
//                            ? 'Add your first user to get started'
//                            : `There are no ${activeTab === 1 ? 'active' : 'inactive'} users at the moment`}
//                      </Text>
//                   </Flex>
//                ) : (
//                   <Flex
//                      wrap="wrap"
//                      gap={{ base: '3', md: '3', lg: '6' }}
//                      justifyContent={{ base: 'center', md: 'flex-start', xl: 'flex-start' }}
//                      w="100%"
//                      overflowY="auto"
//                      h="75vh"
//                      maxW="100%">
//                      {filteredUsers.map((member, index) => (
//                         <Box
//                            key={index}
//                            bg={backgroundColor}
//                            p={3}
//                            borderRadius="md"
//                            boxShadow="sm"
//                            border="1px solid #e2e8f0"
//                            w={{
//                               base: '100%',
//                               sm: 'calc(100% - 12px)',
//                               md: 'calc(50% - 12px)',
//                               lg: '330px',
//                               xl: '360px',
//                            }}
//                            maxW={{
//                               base: '100%',
//                               sm: '100%',
//                               md: '330px',
//                               lg: '330px',
//                               xl: '360px',
//                            }}
//                            h={'fit-content'}
//                            minW="280px"
//                            textAlign="left"
//                            position="relative"
//                            flexShrink={0}>
//                            <Flex align="center" gap={4} mb={3} w="100%">
//                               <Avatar name={member.name} src={member.avatar} size="md" flexShrink={0} />
//                               <Box flex="1" minWidth="0" overflow="hidden">
//                                  <Flex justifyContent="space-between" align="center" mb={2}>
//                                     <Box flex="1" minWidth="0" mr={2}>
//                                        <Text fontWeight="bold" fontSize="md" noOfLines={1} title={member.name}>
//                                           {member.name}
//                                        </Text>
//                                     </Box>
//                                     <Box flexShrink={0}>
//                                        <Badge
//                                           bg={member.status ? 'green.100' : 'red.100'}
//                                           color={member.status ? 'green.800' : 'red.800'}
//                                           borderRadius="full"
//                                           px={3}
//                                           py="5.5px"
//                                           cursor={updatingStatus === member.id ? 'not-allowed' : 'pointer'}
//                                           onClick={
//                                              updatingStatus === member.id ? undefined : () => handleStatusToggle(member)
//                                           }
//                                           _hover={{
//                                              transform: updatingStatus === member.id ? undefined : 'scale(1.05)',
//                                              boxShadow: updatingStatus === member.id ? undefined : 'md',
//                                           }}
//                                           transition="all 0.2s"
//                                           opacity={updatingStatus === member.id ? 0.7 : 1}>
//                                           {updatingStatus === member.id ? (
//                                              <Spinner size="sm" />
//                                           ) : member.status ? (
//                                              'Active'
//                                           ) : (
//                                              'Inactive'
//                                           )}
//                                        </Badge>
//                                     </Box>
//                                  </Flex>

//                                  <Flex align="center" gap={1} mb={1} w="100%" overflow="hidden">
//                                     <CiMail flexShrink={0} />
//                                     <Tooltip label={member.email} placement="top">
//                                        <Text fontSize="sm" color="gray.600" noOfLines={1} isTruncated flex="1">
//                                           {member.email}
//                                        </Text>
//                                     </Tooltip>
//                                  </Flex>

//                                  {member.phone && (
//                                     <Flex align="center" gap={1} w="100%" overflow="hidden">
//                                        <CiPhone flexShrink={0} />
//                                        <Tooltip label={member.phone} placement="top">
//                                           <Text fontSize="sm" color="gray.600" noOfLines={1} isTruncated flex="1">
//                                              {member.phone}
//                                           </Text>
//                                        </Tooltip>
//                                     </Flex>
//                                  )}
//                               </Box>

//                               <Menu>
//                                  <MenuButton
//                                     as={IconButton}
//                                     icon={<CiMenuKebab />}
//                                     size="sm"
//                                     variant="ghost"
//                                     flexShrink={0}
//                                  />
//                                  <MenuList>
//                                     <MenuItem
//                                        icon={<EditIcon />}
//                                        onClick={() => handleEdit(member)}
//                                        isDisabled={member?.isAdmin}>
//                                        Edit
//                                     </MenuItem>
//                                     <MenuItem
//                                        icon={<DeleteIcon />}
//                                        onClick={() => handleDelete(member)}
//                                        isDisabled={member?.isAdmin}>
//                                        Delete
//                                     </MenuItem>
//                                     <MenuItem
//                                        icon={<TbSwitchVertical />}
//                                        onClick={() => {
//                                           setSelectedMember(member);
//                                           setIsOpen(false);
//                                           setIsRoleModalOpen(true);
//                                           onRoleModelOpen();
//                                        }}
//                                        isDisabled={member?.isAdmin}>
//                                        Change Role
//                                     </MenuItem>
//                                  </MenuList>
//                               </Menu>
//                            </Flex>

//                            <Divider />

//                            <Flex justify="space-between" mt={3} align="center" gap={2} w="100%">
//                               <Badge
//                                  bg={
//                                     member?.isAdmin
//                                        ? 'honeydew'
//                                        : member?.userType?.includes('salesman')
//                                        ? '#FFF0F5'
//                                        : 'lavender'
//                                  }
//                                  color={
//                                     member?.isAdmin
//                                        ? 'green.700'
//                                        : member?.userType?.includes('salesman')
//                                        ? 'pink.700'
//                                        : 'gray.700'
//                                  }
//                                  borderRadius="full"
//                                  px={2}
//                                  py={1}
//                                  maxW="60%"
//                                  isTruncated>
//                                  {Array.isArray(member?.userType) && member.userType.length > 0
//                                     ? member.userType
//                                          .map(
//                                             (typeId) => USER_TYPE_OPTIONS.find((option) => option.id === typeId)?.label,
//                                          )
//                                          .join(', ')
//                                     : 'Member'}
//                               </Badge>

//                               {member.createdAt && (
//                                  <Text fontSize="xs" color="gray.500" noOfLines={1} flexShrink={0} textAlign="right">
//                                     Member since {moment(member.createdAt).format('DD/MM/YYYY')}
//                                  </Text>
//                               )}
//                            </Flex>
//                         </Box>
//                      ))}
//                   </Flex>
//                )}
//             </Box>

//             <Modal isOpen={isShareToCompanyModalOpen} onClose={handleCloseShareToCompanyModal} isCentered size="xl">
//                <ModalOverlay />
//                <ModalContent>
//                   <ModalHeader>Share to Company</ModalHeader>
//                   <ModalCloseButton />
//                   <ModalBody>
//                      {companyList
//                         ?.filter((x) => !x.isShared)
//                         ?.map((company, index) => (
//                            <Flex key={index} p={2}>
//                               <Checkbox
//                                  isChecked={selectedCompanies[company.name]}
//                                  onChange={() => handleCompanyChange(company.name)}
//                               />
//                               <Text as="span" ml={'7px'}>
//                                  {company.name}
//                               </Text>
//                            </Flex>
//                         ))}
//                   </ModalBody>
//                   <ModalFooter>
//                      <Button colorScheme="green" variant="ghost" mr={3} onClick={handleCloseShareToCompanyModal}>
//                         Cancel
//                      </Button>
//                      <Button colorScheme="green" variant="solid" mr={3} onClick={handleShareCompany}>
//                         Share
//                      </Button>
//                   </ModalFooter>
//                </ModalContent>
//             </Modal>

//             <AddUserModal
//                isOpen={isOpen}
//                onClose={onClose}
//                isEditMode={isEditMode}
//                userId={userId}
//                isRoleModalOpen={isRoleModalOpen}
//                setIsRoleModalOpen={setIsRoleModalOpen}
//                selectedMember={selectedMember}
//                companyId={companyId}
//                companyList={companyList}
//             />

//             {isRoleModel && (
//                <ManageUserRoleForm
//                   user={user}
//                   selectedMember={selectedMember}
//                   setSelectedMember={setSelectedMember}
//                   isOpen={isRoleModel}
//                   onClose={onCloseRoleModel}
//                   companyList={companyList}
//                />
//             )}

//             <DeleteDialog
//                isDeleteDialogOpen={isDeleteDialogOpen}
//                setDeleteDialogOpen={setDeleteDialogOpen}
//                handleDelete={handleConfirmDelete}
//                title="User"
//             />
//          </Flex>
//       </>
//    );
// }

import {
   Box,
   Flex,
   useColorModeValue,
   Avatar,
   Text,
   Badge,
   VStack,
   HStack,
   IconButton,
   Button,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   useDisclosure,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Checkbox,
   Spacer,
   Divider,
   Tooltip,
   Spinner,
   Tabs,
   TabList,
   Tab,
   Skeleton,
   SkeletonCircle,
   SkeletonText,
   useColorMode,
} from '@chakra-ui/react';
import { EditIcon, DeleteIcon } from '@chakra-ui/icons';
import { TbSwitchVertical } from 'react-icons/tb';
import React, { useEffect, useState, useRef } from 'react';
import { CiMenuKebab, CiShare2, CiPhone, CiMail } from 'react-icons/ci';
import { getUser, deleteUser, updateUserStatus } from '../../../redux/actions/user';
import { useSelector, useDispatch } from 'react-redux';
import ManageUserRoleForm from './ManageUserRoleForm';
import DeleteDialog from 'views/admin/masters/components/DeleteDialog';
import { getCompanies } from '../../../redux/actions/company';
import AddUserModal from './ManageUserForm';
import { Link } from 'react-router-dom';
import { IoMdArrowRoundBack } from 'react-icons/io';
import moment from 'moment';
import { useGlobal } from '../../../contexts';
import { USER_TYPE_OPTIONS } from 'constants';

// Skeleton Loader Components
const UserCardSkeleton = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   return (
      <div
         className={`
         ${
            isDark
               ? 'bg-gradient-to-br from-slate-800/50 via-slate-800/30 to-slate-900/50 border-slate-700/50'
               : 'bg-gradient-to-br from-white via-gray-50/50 to-blue-50/30 border-gray-200/60'
         }
         p-5 rounded-2xl border backdrop-blur-sm
         w-full sm:w-[calc(100%-12px)] md:w-[calc(50%-12px)] lg:w-[330px] xl:w-[360px]
         max-w-full sm:max-w-full md:max-w-[330px] lg:max-w-[330px] xl:max-w-[360px]
         min-w-[280px] h-fit flex-shrink-0
         shadow-lg hover:shadow-xl transition-all duration-300
      `}>
         <div className="flex items-start gap-4 mb-4">
            <SkeletonCircle
               size="56px"
               startColor={isDark ? 'gray.700' : 'gray.200'}
               endColor={isDark ? 'gray.600' : 'gray.300'}
            />
            <div className="flex-1 min-w-0 space-y-3">
               <div className="flex justify-between items-center gap-2">
                  <Skeleton
                     height="22px"
                     width="70%"
                     startColor={isDark ? 'gray.700' : 'gray.200'}
                     endColor={isDark ? 'gray.600' : 'gray.300'}
                     borderRadius="md"
                  />
                  <Skeleton
                     height="26px"
                     width="70px"
                     startColor={isDark ? 'gray.700' : 'gray.200'}
                     endColor={isDark ? 'gray.600' : 'gray.300'}
                     borderRadius="full"
                  />
               </div>
               <div className="space-y-2">
                  <div className="flex items-center gap-2">
                     <div className={`${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        <CiMail size={16} />
                     </div>
                     <Skeleton
                        height="14px"
                        width="85%"
                        startColor={isDark ? 'gray.700' : 'gray.200'}
                        endColor={isDark ? 'gray.600' : 'gray.300'}
                        borderRadius="md"
                     />
                  </div>
                  <div className="flex items-center gap-2">
                     <div className={`${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                        <CiPhone size={16} />
                     </div>
                     <Skeleton
                        height="14px"
                        width="65%"
                        startColor={isDark ? 'gray.700' : 'gray.200'}
                        endColor={isDark ? 'gray.600' : 'gray.300'}
                        borderRadius="md"
                     />
                  </div>
               </div>
            </div>
            <Skeleton
               height="32px"
               width="32px"
               startColor={isDark ? 'gray.700' : 'gray.200'}
               endColor={isDark ? 'gray.600' : 'gray.300'}
               borderRadius="md"
            />
         </div>

         <div
            className={`h-px ${
               isDark
                  ? 'bg-gradient-to-r from-transparent via-slate-600 to-transparent'
                  : 'bg-gradient-to-r from-transparent via-gray-300 to-transparent'
            } my-4`}
         />

         <div className="flex justify-between items-center gap-3">
            <Skeleton
               height="28px"
               width="110px"
               startColor={isDark ? 'gray.700' : 'gray.200'}
               endColor={isDark ? 'gray.600' : 'gray.300'}
               borderRadius="full"
            />
            <Skeleton
               height="16px"
               width="90px"
               startColor={isDark ? 'gray.700' : 'gray.200'}
               endColor={isDark ? 'gray.600' : 'gray.300'}
               borderRadius="md"
            />
         </div>
      </div>
   );
};

const TabSkeleton = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   return (
      <div className="mb-0 mt-6">
         <Skeleton
            height="46px"
            width="340px"
            borderRadius="full"
            startColor={isDark ? 'gray.700' : 'gray.200'}
            endColor={isDark ? 'gray.600' : 'gray.300'}
         />
      </div>
   );
};

const HeaderSkeleton = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   return (
      <div className="flex justify-between w-full mt-8">
         <div className="flex items-center gap-4">
            <Skeleton
               height="44px"
               width="44px"
               borderRadius="xl"
               startColor={isDark ? 'gray.700' : 'gray.200'}
               endColor={isDark ? 'gray.600' : 'gray.300'}
            />
            <Skeleton
               height="36px"
               width="120px"
               borderRadius="lg"
               startColor={isDark ? 'gray.700' : 'gray.200'}
               endColor={isDark ? 'gray.600' : 'gray.300'}
            />
         </div>
         <Skeleton
            height="44px"
            width="130px"
            borderRadius="full"
            startColor={isDark ? 'gray.700' : 'gray.200'}
            endColor={isDark ? 'gray.600' : 'gray.300'}
         />
      </div>
   );
};

export default function ManageUsers(props) {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [selectedMember, setSelectedMember] = useState(null);
   const [userId, setUserId] = useState(null);
   const [companyId, setCompanyId] = useState('');
   const [error, setError] = useState('');
   const [isEditMode, setIsEditMode] = useState(false);
   const [updatingStatus, setUpdatingStatus] = useState(null);
   const { isOpen, onOpen, onClose } = useDisclosure();
   const setIsOpen = (value) => {
      if (value) {
         onOpen();
      } else {
         onClose();
      }
   };
   const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const { companyList } = useGlobal();

   const dispatch = useDispatch();
   const list = useSelector((state) => state.user.list);
   const user = useSelector((state) => state.user?.profile);
   const [isLoading, setIsLoading] = useState(true);

   const { isOpen: isRoleModel, onOpen: onRoleModelOpen, onClose: onCloseRoleModel } = useDisclosure();

   useEffect(() => {
      const fetchData = async () => {
         try {
            setIsLoading(true);
            await dispatch(getUser());
         } catch (error) {
            console.error('Error fetching data:', error);
         } finally {
            setIsLoading(false);
         }
      };

      fetchData();
   }, [dispatch]);

   const [isShareToCompanyModalOpen, setIsShareToCompanyModalOpen] = useState(false);

   const handleCloseShareToCompanyModal = () => {
      setIsShareToCompanyModalOpen(false);
   };

   const handleStatusToggle = async (member) => {
      setUpdatingStatus(member.id);
      try {
         await dispatch(updateUserStatus(member.id, !member.status));
      } catch (error) {
         console.error('Error updating status:', error);
      } finally {
         setUpdatingStatus(null);
      }
   };

   const [selectedCompanies, setSelectedCompanies] = useState({
      'Comp Update': false,
      'Long Best Co': false,
      'SS WEB CREATION': false,
      'TEST COMPANY NAME': false,
   });

   const handleCompanyChange = (companyName) => {
      setSelectedCompanies((prev) => ({
         ...prev,
         [companyName]: !prev[companyName],
      }));
   };

   const handleShareCompany = () => {
      const selectedCompanyData = {};

      Object.keys(selectedCompanies).forEach((company) => {
         selectedCompanyData[company.toLowerCase()] = {
            companyName: company,
            isSelected: selectedCompanies[company],
         };
      });

      setIsShareToCompanyModalOpen(false);
   };

   const handleEdit = (member) => {
      setSelectedMember(member);
      setUserId(member.id);
      setIsEditMode(true);
      setCompanyId(member.companyId);
      onOpen();
   };

   const [selectedRowId, setSelectedRowId] = useState(null);
   const [data, setData] = useState([]);

   const handleDelete = async (member) => {
      setSelectedRowId(member.id);
      setDeleteDialogOpen(true);
   };

   const handleConfirmDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deleteUser(selectedRowId));
            setData(data?.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false);
            await dispatch(getUser());
         } catch (err) {
            // console.error('Failed to delete series:', err);
         }
      }
   };

   const handleAddNew = () => {
      setIsEditMode(false);
      setError('');
      onOpen();
   };

   const scrollContainerRef = useRef(null);

   useEffect(() => {
      const handleScroll = (e) => {
         // Optional: Add any scroll behavior customization here
      };

      const scrollContainer = scrollContainerRef.current;
      if (scrollContainer) {
         scrollContainer.addEventListener('scroll', handleScroll);
      }

      return () => {
         if (scrollContainer) {
            scrollContainer.removeEventListener('scroll', handleScroll);
         }
      };
   }, []);

   useEffect(() => {
      const handleKeyDown = (event) => {
         if (event.key === '+' || (event.key === '=' && event.shiftKey)) {
            event.preventDefault();
            handleAddNew();
         }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   const [activeTab, setActiveTab] = useState(1);

   const getFilteredUsers = () => {
      const filteredList = list.filter((member) => member.id !== user?.id);

      if (activeTab === 0) return filteredList;
      if (activeTab === 1) return filteredList.filter((member) => member.status);
      if (activeTab === 2) return filteredList.filter((member) => !member.status);

      return filteredList;
   };

   const filteredUsers = getFilteredUsers();

   const allCount = list?.filter((member) => member.id !== user?.id).length || 0;
   const activeCount = list?.filter((member) => member.id !== user?.id && member.status).length || 0;
   const inactiveCount = list?.filter((member) => member.id !== user?.id && !member.status).length || 0;

   return (
      <>
         <div
            className={` mt-10
            min-h-[85vh] max-h-[85vh] flex flex-col w-full
            ${isDark ? 'bg-slate-900/50' : 'bg-gray-50/50'}
         `}>
            <div className="p-3 rounded-xl w-full">
               {/* Modern Tab Interface */}
               {isLoading ? (
                  <TabSkeleton />
               ) : (
                  <div className="mb-0 mt-2">
                     <div
                        className={`
                        inline-flex gap-1.5 p-1.5 rounded-full shadow-lg
                        ${
                           isDark
                              ? 'bg-gradient-to-r from-slate-800/90 via-slate-800/80 to-slate-900/90 border border-slate-700/50'
                              : 'bg-white/80 backdrop-blur-md border border-gray-200/60'
                        }
                     `}>
                        {/* All Tab */}
                        <button
                           onClick={() => setActiveTab(0)}
                           className={`
                              px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300
                              flex items-center gap-2
                              ${
                                 activeTab === 0
                                    ? isDark
                                       ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg shadow-blue-500/30'
                                       : 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-200/50'
                                    : isDark
                                    ? 'text-gray-400 hover:text-gray-200 hover:bg-slate-700/50'
                                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100/70'
                              }
                           `}>
                           <span>All</span>
                           <span
                              className={`
                              px-2.5 py-0.5 rounded-full text-xs font-bold
                              ${
                                 activeTab === 0
                                    ? isDark
                                       ? 'bg-white/20 text-white'
                                       : 'bg-white/30 text-white'
                                    : isDark
                                    ? 'bg-slate-700/60 text-gray-300'
                                    : 'bg-gray-200/70 text-gray-600'
                              }
                           `}>
                              {allCount}
                           </span>
                        </button>

                        {/* Active Tab */}
                        <button
                           onClick={() => setActiveTab(1)}
                           className={`
                              px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300
                              flex items-center gap-2
                              ${
                                 activeTab === 1
                                    ? isDark
                                       ? 'bg-gradient-to-r from-emerald-600 to-emerald-700 text-white shadow-lg shadow-emerald-500/30'
                                       : 'bg-gradient-to-r from-emerald-500 to-emerald-600 text-white shadow-lg shadow-emerald-200/50'
                                    : isDark
                                    ? 'text-gray-400 hover:text-gray-200 hover:bg-slate-700/50'
                                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100/70'
                              }
                           `}>
                           <span>Active</span>
                           <span
                              className={`
                              px-2.5 py-0.5 rounded-full text-xs font-bold
                              ${
                                 activeTab === 1
                                    ? isDark
                                       ? 'bg-white/20 text-white'
                                       : 'bg-white/30 text-white'
                                    : isDark
                                    ? 'bg-slate-700/60 text-gray-300'
                                    : 'bg-gray-200/70 text-gray-600'
                              }
                           `}>
                              {activeCount}
                           </span>
                        </button>

                        {/* Inactive Tab */}
                        <button
                           onClick={() => setActiveTab(2)}
                           className={`
                              px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-300
                              flex items-center gap-2
                              ${
                                 activeTab === 2
                                    ? isDark
                                       ? 'bg-gradient-to-r from-rose-600 to-rose-700 text-white shadow-lg shadow-rose-500/30'
                                       : 'bg-gradient-to-r from-rose-500 to-rose-600 text-white shadow-lg shadow-rose-200/50'
                                    : isDark
                                    ? 'text-gray-400 hover:text-gray-200 hover:bg-slate-700/50'
                                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100/70'
                              }
                           `}>
                           <span>Inactive</span>
                           <span
                              className={`
                              px-2.5 py-0.5 rounded-full text-xs font-bold
                              ${
                                 activeTab === 2
                                    ? isDark
                                       ? 'bg-white/20 text-white'
                                       : 'bg-white/30 text-white'
                                    : isDark
                                    ? 'bg-slate-700/60 text-gray-300'
                                    : 'bg-gray-200/70 text-gray-600'
                              }
                           `}>
                              {inactiveCount}
                           </span>
                        </button>
                     </div>
                  </div>
               )}

               {isLoading ? (
                  <HeaderSkeleton />
               ) : (
                  <div className="flex justify-between w-full mt-4 mb-3">
                     <div className="flex items-center gap-4">
                        <Link to="/admin/setting">
                           <button
                              className={`
                              p-3 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg
                              ${
                                 isDark
                                    ? 'bg-gradient-to-br from-slate-700 to-slate-800 hover:from-slate-600 hover:to-slate-700 text-white border border-slate-600/50'
                                    : 'bg-gradient-to-br from-white to-gray-50 hover:from-gray-50 hover:to-gray-100 text-gray-700 border border-gray-200/60'
                              }
                           `}>
                              <IoMdArrowRoundBack size={20} />
                           </button>
                        </Link>

                        <h1
                           className={`
                           text-3xl font-bold
                           ${
                              isDark
                                 ? 'bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent'
                                 : 'bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent'
                           }
                        `}>
                           Users
                        </h1>
                     </div>

                     <button
                        onClick={handleAddNew}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                           isDark
                              ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                              : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                        }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                              isDark ? 'via-cyan-100/20' : 'via-white/30'
                           }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                              isDark
                                 ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                                 : 'bg-white/20 group-hover:bg-white/30'
                           }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  </div>
               )}

               {/* User Cards */}
               {isLoading ? (
                  <div className="flex flex-wrap gap-4 lg:gap-6 justify-center md:justify-start overflow-y-auto h-[75vh] w-full max-w-full">
                     {Array.from({ length: 6 }).map((_, index) => (
                        <UserCardSkeleton key={index} />
                     ))}
                  </div>
               ) : filteredUsers.length === 0 ? (
                  <div
                     className={`
                     flex flex-col items-center justify-center min-h-[300px] rounded-2xl p-8 shadow-lg
                     ${
                        isDark
                           ? 'bg-gradient-to-br from-slate-800/40 to-slate-900/40 border border-slate-700/50'
                           : 'bg-gradient-to-br from-white to-blue-50/30 border border-gray-200/60'
                     }
                  `}>
                     <div
                        className={`
                        text-6xl mb-4
                        ${isDark ? 'text-slate-600' : 'text-gray-300'}
                     `}>
                        👥
                     </div>
                     <Text fontSize="lg" fontWeight="600" className={isDark ? 'text-gray-300' : 'text-gray-600'}>
                        No {activeTab === 1 ? 'active' : activeTab === 2 ? 'inactive' : ''} users found
                     </Text>
                     <Text fontSize="sm" className={`mt-2 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                        {activeTab === 0
                           ? 'Add your first user to get started'
                           : `There are no ${activeTab === 1 ? 'active' : 'inactive'} users at the moment`}
                     </Text>
                  </div>
               ) : (
                  <div className="flex flex-wrap gap-4 py-2 px-2 lg:gap-6 justify-center md:justify-start overflow-y-auto h-[75vh] w-full max-w-full">
                     {filteredUsers.map((member, index) => (
                        <div
                           key={index}
                           className={`
                              p-3 rounded-2xl border backdrop-blur-sm
                              w-full sm:w-[calc(100%-12px)] md:w-[calc(50%-12px)] lg:w-[330px] xl:w-[360px]
                              max-w-full sm:max-w-full md:max-w-[330px] lg:max-w-[330px] xl:max-w-[360px]
                              min-w-[280px] h-fit flex-shrink-0
                              transition-all duration-300 hover:scale-[1.02]
                              ${
                                 isDark
                                    ? 'bg-gradient-to-br from-slate-800/50 via-slate-800/30 to-slate-900/50 border-slate-700/50 hover:border-slate-600/70 shadow-lg hover:shadow-xl hover:shadow-blue-500/10'
                                    : 'bg-gradient-to-br from-white via-gray-50/50 to-blue-50/30 border-gray-200/60 hover:border-blue-300/50 shadow-lg hover:shadow-xl hover:shadow-blue-200/30'
                              }
                           `}>
                           <div className="flex items-start gap-4 mb-4">
                              <Avatar
                                 name={member.name}
                                 src={member.avatar}
                                 size="md"
                                 className={`flex-shrink-0 ring-2 ${isDark ? 'ring-slate-700/50' : 'ring-blue-100/50'}`}
                              />
                              <div className="flex-1 min-w-0 overflow-hidden">
                                 <div className="flex justify-between items-center mb-3 gap-2">
                                    <div className="flex-1 min-w-0 mr-2">
                                       <Tooltip label={member.name} placement="top">
                                          <Text
                                             fontWeight="bold"
                                             fontSize="md"
                                             noOfLines={1}
                                             className={isDark ? 'text-white' : 'text-gray-900'}>
                                             {member.name}
                                          </Text>
                                       </Tooltip>
                                    </div>
                                    <div className="flex-shrink-0">
                                       <button
                                          disabled={updatingStatus === member.id}
                                          onClick={
                                             updatingStatus === member.id ? undefined : () => handleStatusToggle(member)
                                          }
                                          className={`
                                             px-3 py-1 rounded-full text-xs font-bold
                                             transition-all duration-300 shadow-md
                                             ${
                                                updatingStatus === member.id
                                                   ? 'cursor-not-allowed opacity-70'
                                                   : 'hover:scale-105 hover:shadow-lg cursor-pointer'
                                             }
                                             ${
                                                member.status
                                                   ? isDark
                                                      ? 'bg-gradient-to-r from-emerald-600/80 to-emerald-700/80 text-white shadow-emerald-500/20'
                                                      : 'bg-gradient-to-r from-emerald-100 to-emerald-200 text-emerald-800 shadow-emerald-200/50'
                                                   : isDark
                                                   ? 'bg-gradient-to-r from-rose-600/80 to-rose-700/80 text-white shadow-rose-500/20'
                                                   : 'bg-gradient-to-r from-rose-100 to-rose-200 text-rose-800 shadow-rose-200/50'
                                             }
                                          `}>
                                          {updatingStatus === member.id ? (
                                             <Spinner size="sm" />
                                          ) : member.status ? (
                                             'Active'
                                          ) : (
                                             'Inactive'
                                          )}
                                       </button>
                                    </div>
                                 </div>

                                 <div className="space-y-1">
                                    <div className="flex items-center gap-2 overflow-hidden">
                                       <CiMail
                                          className={`flex-shrink-0 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}
                                          size={16}
                                       />
                                       <Tooltip label={member.email} placement="top">
                                          <Text
                                             fontSize="sm"
                                             noOfLines={1}
                                             isTruncated
                                             className={`flex-1 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                             {member.email}
                                          </Text>
                                       </Tooltip>
                                    </div>

                                    {member.phone && (
                                       <div className="flex items-center gap-2 overflow-hidden">
                                          <CiPhone
                                             className={`flex-shrink-0 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}
                                             size={16}
                                          />
                                          <Tooltip label={member.phone} placement="top">
                                             <Text
                                                fontSize="sm"
                                                noOfLines={1}
                                                isTruncated
                                                className={`flex-1 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                                {member.phone}
                                             </Text>
                                          </Tooltip>
                                       </div>
                                    )}
                                 </div>
                              </div>

                              <Menu placement="bottom-end" strategy="fixed">
                                 <MenuButton
                                    as={IconButton}
                                    icon={<CiMenuKebab />}
                                    size="sm"
                                    variant="ghost"
                                    className={`flex-shrink-0 ${
                                       isDark
                                          ? 'hover:bg-slate-700/50 text-gray-400'
                                          : 'hover:bg-gray-100 text-gray-600'
                                    }`}
                                 />
                                 <MenuList>
                                    <MenuItem
                                       icon={<EditIcon />}
                                       onClick={() => handleEdit(member)}
                                       isDisabled={member?.isAdmin}>
                                       Edit
                                    </MenuItem>
                                    <MenuItem
                                       icon={<DeleteIcon />}
                                       onClick={() => handleDelete(member)}
                                       isDisabled={member?.isAdmin}>
                                       Delete
                                    </MenuItem>
                                    <MenuItem
                                       icon={<TbSwitchVertical />}
                                       onClick={() => {
                                          setSelectedMember(member);
                                          setIsOpen(false);
                                          setIsRoleModalOpen(true);
                                          onRoleModelOpen();
                                       }}
                                       isDisabled={member?.isAdmin}>
                                       Change Role
                                    </MenuItem>
                                 </MenuList>
                              </Menu>
                           </div>

                           <div
                              className={`
                              h-px my-2
                              ${
                                 isDark
                                    ? 'bg-gradient-to-r from-transparent via-slate-600 to-transparent'
                                    : 'bg-gradient-to-r from-transparent via-gray-300 to-transparent'
                              }
                           `}
                           />

                           <div className="flex justify-between items-center gap-3 mt-2">
                              <div
                                 className={`
                                 px-3 py-2 rounded-full text-xs font-semibold max-w-[60%] truncate shadow-sm
                                 ${
                                    member?.isAdmin
                                       ? isDark
                                          ? 'bg-gradient-to-r from-teal-600/30 to-teal-700/30 text-teal-300 border border-teal-500/30'
                                          : 'bg-gradient-to-r from-teal-50 to-teal-100 text-teal-700 border border-teal-200/50'
                                       : member?.userType?.includes('salesman')
                                       ? isDark
                                          ? 'bg-gradient-to-r from-pink-600/30 to-pink-700/30 text-pink-300 border border-pink-500/30'
                                          : 'bg-gradient-to-r from-pink-50 to-pink-100 text-pink-700 border border-pink-200/50'
                                       : isDark
                                       ? 'bg-gradient-to-r from-purple-600/30 to-purple-700/30 text-purple-300 border border-purple-500/30'
                                       : 'bg-gradient-to-r from-purple-50 to-purple-100 text-purple-700 border border-purple-200/50'
                                 }
                              `}>
                                 {Array.isArray(member?.userType) && member.userType.length > 0
                                    ? member.userType
                                         .map(
                                            (typeId) => USER_TYPE_OPTIONS.find((option) => option.id === typeId)?.label,
                                         )
                                         .join(', ')
                                    : 'Member'}
                              </div>

                              {member.createdAt && (
                                 <Text
                                    fontSize="xs"
                                    noOfLines={1}
                                    className={`flex-shrink-0 text-right ${
                                       isDark ? 'text-gray-500' : 'text-gray-400'
                                    }`}>
                                    Member since {moment(member.createdAt).format('DD/MM/YYYY')}
                                 </Text>
                              )}
                           </div>
                        </div>
                     ))}
                  </div>
               )}
            </div>

            <Modal isOpen={isShareToCompanyModalOpen} onClose={handleCloseShareToCompanyModal} isCentered size="xl">
               <ModalOverlay />
               <ModalContent>
                  <ModalHeader>Share to Company</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                     {companyList
                        ?.filter((x) => !x.isShared)
                        ?.map((company, index) => (
                           <Flex key={index} p={2}>
                              <Checkbox
                                 isChecked={selectedCompanies[company.name]}
                                 onChange={() => handleCompanyChange(company.name)}
                              />
                              <Text as="span" ml={'7px'}>
                                 {company.name}
                              </Text>
                           </Flex>
                        ))}
                  </ModalBody>
                  <ModalFooter>
                     <Button colorScheme="green" variant="ghost" mr={3} onClick={handleCloseShareToCompanyModal}>
                        Cancel
                     </Button>
                     <Button colorScheme="green" variant="solid" mr={3} onClick={handleShareCompany}>
                        Share
                     </Button>
                  </ModalFooter>
               </ModalContent>
            </Modal>

            <AddUserModal
               isOpen={isOpen}
               onClose={onClose}
               isEditMode={isEditMode}
               userId={userId}
               isRoleModalOpen={isRoleModalOpen}
               setIsRoleModalOpen={setIsRoleModalOpen}
               selectedMember={selectedMember}
               companyId={companyId}
               companyList={companyList}
            />

            {isRoleModel && (
               <ManageUserRoleForm
                  user={user}
                  selectedMember={selectedMember}
                  setSelectedMember={setSelectedMember}
                  isOpen={isRoleModel}
                  onClose={onCloseRoleModel}
                  companyList={companyList}
               />
            )}

            <DeleteDialog
               isDeleteDialogOpen={isDeleteDialogOpen}
               setDeleteDialogOpen={setDeleteDialogOpen}
               handleDelete={handleConfirmDelete}
               title="User"
            />
         </div>
      </>
   );
}
